import React from "react";
import "./About.css";
import img1 from "../../Images/Restaurant/aboutCulinary.jpg";
import img2 from "../../Images/fourSeasonsStart.jpg";

function About() {
  return (
    <div className="about-container">
      {/* <hr style={{ borderColor: "#faf7f7" }}></hr> */}
      <div className="upper">
        <figure className="fig1">
          <img src={img1} alt="img1" className="about-img1" />{" "}
        </figure>
        <div className="upper-details">
          <p className="upper-details-title">Culinary Excellence Lounge</p>
          <p className="upper-details-about">
          At our resort, we pride ourselves on offering a delightful culinary experience with a diverse menu. Savor the rich flavors of authentic Indian dishes, the delicate balance of Chinese cuisine, and the refined elegance of Continental fare. Every meal is crafted with fresh ingredients, ensuring a dining experience that's both satisfying and memorable amidst breathtaking surroundings.
          </p>
        </div>
      </div>
      <div className="lower">
        <figure className="fig2">
          <img src={img2} alt="img2" className="about-img2" />
        </figure>
        <div className="lower-details">
          <p className="upper-details-title">The Serenity Haven</p>
          <p className="upper-details-about">
          Escape to a sanctuary where tranquility meets luxury, offering a serene retreat from the everyday. Nestled amidst nature's beauty, this haven provides an idyllic setting to unwind and rejuvenate. With every detail crafted for comfort and relaxation, guests can immerse themselves in peaceful surroundings while indulging in world-class amenities and personalized service. This is where serenity finds its true home. 
          </p>
        </div>
      </div>
      
    </div>
  );
}

export default About;
